import type { Params } from "react-router";

/** The params object `useParams` resolves for the current URL. */
export type RouteParams = Readonly<Params<string>>;

/**
 * Reads a param the hosting route's pattern is expected to provide, for
 * passing to an `appPaths.x.build(...)` call. Throwing on a missing param
 * turns a route-config mistake into a loud render error instead of a
 * silently broken URL.
 */
export function requireRouteParam(params: RouteParams, name: string): string {
  const value = params[name];
  if (value === undefined) {
    throw new Error(`Route param "${name}" is missing`);
  }
  return value;
}
